module.exports = __webpack_public_path__ + "static/media/Mario_Alberto_Agraz.bf538522.png";